import React from "react";
import { Box, Button, Chip, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import SaveIcon from "@material-ui/icons/Save";
import { formatCreatedAt } from "../constants";
import useAssistedAffiliationStyles from "../styles";

type RequestActionToolbarProps = {
  status: string;
  /** Fecha ISO de la última modificación. Una solicitud nueva todavía no tiene. */
  lastUpdatedAt?: string;
  createDisabled: boolean;
  isCreating: boolean;
  showSubmitActions?: boolean;
  saveLabel?: string;
  isSaving?: boolean;
  onBack: () => void;
  onSaveDraft: () => void;
  onCreateCommerce: () => void;
};

const RequestActionToolbar = ({
  status,
  lastUpdatedAt,
  createDisabled,
  isCreating,
  showSubmitActions = true,
  saveLabel = "Guardar borrador",
  isSaving = false,
  onBack,
  onSaveDraft,
  onCreateCommerce,
}: RequestActionToolbarProps) => {
  const classes = useAssistedAffiliationStyles();

  return (
    <Box className={classes.toolbar}>
      <Button
        className={classes.backButton}
        startIcon={<ArrowBackIcon />}
        onClick={onBack}
      >
        Volver
      </Button>
      <Box className={classes.actions}>
        {lastUpdatedAt ? (
          <Typography className={classes.lastUpdatedLabel}>
            {`Última modificación: ${formatCreatedAt(lastUpdatedAt)}`}
          </Typography>
        ) : null}
        <Chip label={status} className={classes.draftChip} />
        {showSubmitActions ? (
          <>
            <Button
              className={classes.saveButton}
              variant="contained"
              startIcon={<SaveIcon />}
              disabled={isSaving}
              onClick={onSaveDraft}
            >
              {isSaving ? "Guardando..." : saveLabel}
            </Button>
            <Button
              className={classes.createButton}
              variant="contained"
              startIcon={<CheckCircleOutlineIcon />}
              disabled={createDisabled}
              onClick={onCreateCommerce}
            >
              {isCreating ? "Creando..." : "Crear comercio"}
            </Button>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default RequestActionToolbar;
